import { createContext } from 'react';

import type { MapAnalysisRegionDrawingContextValue } from '@/features/map/context/mapAnalysisRegionDrawingContext.types';

/**
 * Tách `createContext` ra module tối thiểu để consumer (lazy map) không cùng evaluation graph
 * với Provider/modals — tránh hai bản Context trong dev (Vite/HMR, circular chunk).
 */
export const MapAnalysisRegionDrawingContext =
  createContext<MapAnalysisRegionDrawingContextValue | null>(null);
